export const getLiveProgress = (startTime: Date, endTime: Date): number => {
  const currentTime = new Date().getTime();
  const startingTime = startTime.getTime();
  const endingTime = endTime.getTime();

  const progress = ((currentTime - startingTime) / (endingTime - startingTime)) * 100;

  return progress > 100 ? 100 : progress;
};

export default getLiveProgress;
